import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

const ChangeFlightButton = ({ onClick, className, visible = true }) => (
  <Typography
    variant="body2"
    component="button"
    className={className}
    onClick={onClick}
    sx={{
      color: 'primary.main',
      paddingTop: '2px',
      visibility: visible ? 'visible' : 'hidden',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      textDecoration: 'none',
    }}
  >
    Change flight
  </Typography>
);

ChangeFlightButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  className: PropTypes.string,
};

ChangeFlightButton.defaultProps = {
  visible: true,
  className: 'text-sm',
};
export default ChangeFlightButton;
